module.exports = __webpack_public_path__ + "static/media/bg-profile.b190b66c.jpg";